import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-carousel-item.component.scss';
var ImageCarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(ImageCarouselItem, _super);
    function ImageCarouselItem(element) {
        return _super.call(this, element) || this;
    }
    ImageCarouselItem.prototype.init = function () { };
    ;
    ImageCarouselItem.prototype.bindEvents = function () { };
    ;
    return ImageCarouselItem;
}(Base));
export { ImageCarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/image-carousel-item/image-carousel-item.component.ts
// module id = 368
// module chunks = 0